import { useEffect } from 'react';
import Navbar from '../../../components/feature/Navbar';
import Footer from '../../../components/feature/Footer';
import FloatingButtons from '../../../components/feature/FloatingButtons';

const IngiltereVizesiPage = () => {
  useEffect(() => {
    document.title = 'İngiltere Vizesi | İzmir Vize Danışmanlığı';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'İngiltere turistik, ticari ve öğrenci vize başvuruları. UK vize süreçlerinde profesyonel danışmanlık hizmeti.');
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <main className="pt-20">
        {/* Hero Section */}
        <section className="relative py-16 md:py-24 overflow-hidden">
          <div className="absolute inset-0 z-0">
            <img
              src="https://public.readdy.ai/ai/img_res/c5bd3906f6b8f2dc89c70983c8581662.jpg"
              alt="İngiltere Vizesi"
              className="w-full h-full object-cover object-center"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-navy-900/95 via-navy-900/90 to-navy-900/95"></div>
          </div>
          
          <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
            <span className="inline-block px-4 py-2 md:px-6 md:py-3 bg-cream-400 text-navy-900 text-xs font-semibold tracking-widest uppercase rounded-full mb-4 md:mb-6">
              UK Vizesi
            </span>
            <h1 className="font-display text-3xl md:text-5xl lg:text-6xl font-bold text-cream-100 mb-4 md:mb-6">
              İngiltere Vize Danışmanlığı
            </h1>
            <p className="text-cream-200 text-base md:text-xl lg:text-2xl leading-relaxed mb-6 md:mb-8">
              Turistik, ticari, öğrenci ve çalışma vizelerinde profesyonel destek
            </p>
            <div className="flex flex-col sm:flex-row gap-3 md:gap-4">
              <a
                href="https://wa.me/905514803007?text=Merhaba%2C%20karsiyakavisaconsulting.com.tr%20web%20siteniz%20%C3%BCzerinden%20yaz%C4%B1yorum."
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center px-6 py-3 md:px-8 md:py-4 bg-green-600 text-white rounded-full font-bold text-sm md:text-lg hover:bg-green-700 transition-all hover:scale-105 shadow-xl cursor-pointer whitespace-nowrap"
              >
                <i className="ri-whatsapp-fill text-xl md:text-2xl mr-2"></i>
                WhatsApp ile İletişim
              </a>
              <a
                href="tel:+905514803007"
                className="inline-flex items-center justify-center px-6 py-3 md:px-8 md:py-4 bg-cream-400 text-navy-900 rounded-full font-bold text-sm md:text-lg hover:bg-cream-300 transition-all hover:scale-105 shadow-xl cursor-pointer whitespace-nowrap"
              >
                <i className="ri-phone-fill text-xl md:text-2xl mr-2"></i>
                Hemen Ara
              </a>
            </div>
          </div>
        </section>

        {/* Content Section */}
        <section className="py-12 md:py-20 bg-white">
          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="prose prose-lg max-w-none">
              <h2 className="font-display text-2xl md:text-4xl font-bold text-navy-900 mb-4 md:mb-6">
                İngiltere Vizesi Nedir?
              </h2>
              <p className="text-navy-700 text-base md:text-lg leading-relaxed mb-6">
                İngiltere vizesi, Birleşik Krallık'a (İngiltere, İskoçya, Galler ve Kuzey İrlanda) seyahat etmek isteyen Türk vatandaşları için zorunlu bir belgedir. Brexit sonrası İngiltere Schengen bölgesinden ayrıldığı için ayrı bir vize başvurusu gerektirir.
              </p>
              <p className="text-navy-700 text-base md:text-lg leading-relaxed mb-8">
                İngiltere vize sistemi, seyahat amacına göre farklı kategorilere ayrılmıştır. Her vize türü için farklı gereksinimler ve prosedürler bulunmaktadır. Başvuru süreci online olarak başlar ve biyometrik veri toplama merkezi ziyareti gerektirir.
              </p>

              <h2 className="font-display text-2xl md:text-4xl font-bold text-navy-900 mb-4 md:mb-6">
                İngiltere Vize Türleri
              </h2>
              <div className="grid md:grid-cols-2 gap-4 md:gap-6 mb-8">
                <div className="bg-gradient-to-br from-navy-900 to-navy-800 rounded-2xl p-6">
                  <div className="w-12 h-12 bg-cream-400 rounded-xl flex items-center justify-center mb-4">
                    <i className="ri-plane-line text-2xl text-navy-900"></i>
                  </div>
                  <h3 className="font-display text-xl font-bold text-cream-100 mb-2">Standard Visitor Visa</h3>
                  <p className="text-cream-200 text-sm">Turizm, iş ziyareti, aile ziyareti ve kısa süreli eğitim programları için 6 aya kadar geçerli vize.</p>
                </div>
                <div className="bg-gradient-to-br from-cream-400 to-cream-300 rounded-2xl p-6">
                  <div className="w-12 h-12 bg-navy-900 rounded-xl flex items-center justify-center mb-4">
                    <i className="ri-briefcase-line text-2xl text-cream-100"></i>
                  </div>
                  <h3 className="font-display text-xl font-bold text-navy-900 mb-2">Business Visitor Visa</h3>
                  <p className="text-navy-700 text-sm">İş görüşmeleri, konferanslar, fuarlar ve ticari faaliyetler için düzenlenir.</p>
                </div>
                <div className="bg-gradient-to-br from-cream-300 to-cream-200 rounded-2xl p-6">
                  <div className="w-12 h-12 bg-navy-900 rounded-xl flex items-center justify-center mb-4">
                    <i className="ri-book-open-line text-2xl text-cream-100"></i>
                  </div>
                  <h3 className="font-display text-xl font-bold text-navy-900 mb-2">Student Visa (Tier 4)</h3>
                  <p className="text-navy-700 text-sm">Üniversite veya dil okulu eğitimi için uzun süreli öğrenci vizesi.</p>
                </div>
                <div className="bg-gradient-to-br from-navy-800 to-navy-700 rounded-2xl p-6">
                  <div className="w-12 h-12 bg-cream-400 rounded-xl flex items-center justify-center mb-4">
                    <i className="ri-user-star-line text-2xl text-navy-900"></i>
                  </div>
                  <h3 className="font-display text-xl font-bold text-cream-100 mb-2">Skilled Worker Visa</h3>
                  <p className="text-cream-200 text-sm">Nitelikli iş pozisyonları için çalışma vizesi.</p>
                </div>
              </div>

              <h2 className="font-display text-2xl md:text-4xl font-bold text-navy-900 mb-4 md:mb-6">
                Standard Visitor Visa Başvuru Süreci
              </h2>
              <div className="space-y-4 mb-8">
                <div className="flex items-start gap-4 bg-cream-50 rounded-xl p-4 md:p-6 border-2 border-cream-200">
                  <div className="w-10 h-10 bg-navy-900 rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-cream-100 font-bold">1</span>
                  </div>
                  <div>
                    <h3 className="font-bold text-navy-900 text-lg mb-2">Online Başvuru Formu</h3>
                    <p className="text-navy-600">UK Visas and Immigration web sitesinden online başvuru formu doldurulur.</p>
                  </div>
                </div>
                <div className="flex items-start gap-4 bg-cream-50 rounded-xl p-4 md:p-6 border-2 border-cream-200">
                  <div className="w-10 h-10 bg-navy-900 rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-cream-100 font-bold">2</span>
                  </div>
                  <div>
                    <h3 className="font-bold text-navy-900 text-lg mb-2">Vize Ücreti Ödeme</h3>
                    <p className="text-navy-600">Başvuru ücreti (yaklaşık 100-115 GBP) online olarak ödenir.</p>
                  </div>
                </div>
                <div className="flex items-start gap-4 bg-cream-50 rounded-xl p-4 md:p-6 border-2 border-cream-200">
                  <div className="w-10 h-10 bg-navy-900 rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-cream-100 font-bold">3</span>
                  </div>
                  <div>
                    <h3 className="font-bold text-navy-900 text-lg mb-2">Randevu Alma</h3>
                    <p className="text-navy-600">VFS Global vize başvuru merkezinden biyometrik veri toplama randevusu alınır.</p>
                  </div>
                </div>
                <div className="flex items-start gap-4 bg-cream-50 rounded-xl p-4 md:p-6 border-2 border-cream-200">
                  <div className="w-10 h-10 bg-navy-900 rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-cream-100 font-bold">4</span>
                  </div>
                  <div>
                    <h3 className="font-bold text-navy-900 text-lg mb-2">Evrak Hazırlığı</h3>
                    <p className="text-navy-600">Tüm destekleyici belgeler hazırlanır ve organize edilir.</p>
                  </div>
                </div>
                <div className="flex items-start gap-4 bg-cream-50 rounded-xl p-4 md:p-6 border-2 border-cream-200">
                  <div className="w-10 h-10 bg-navy-900 rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-cream-100 font-bold">5</span>
                  </div>
                  <div>
                    <h3 className="font-bold text-navy-900 text-lg mb-2">Biyometrik Veri Toplama</h3>
                    <p className="text-navy-600">Randevu gününde VFS merkezine gidilir, parmak izi ve fotoğraf alınır, evraklar teslim edilir.</p>
                  </div>
                </div>
                <div className="flex items-start gap-4 bg-cream-50 rounded-xl p-4 md:p-6 border-2 border-cream-200">
                  <div className="w-10 h-10 bg-navy-900 rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-cream-100 font-bold">6</span>
                  </div>
                  <div>
                    <h3 className="font-bold text-navy-900 text-lg mb-2">Değerlendirme ve Sonuç</h3>
                    <p className="text-navy-600">Başvuru 15-20 iş günü içinde değerlendirilir ve sonuç bildirilir.</p>
                  </div>
                </div>
              </div>

              <h2 className="font-display text-2xl md:text-4xl font-bold text-navy-900 mb-4 md:mb-6">
                Gerekli Evraklar
              </h2>
              <div className="bg-gradient-to-br from-navy-900 to-navy-800 rounded-2xl p-6 md:p-8 mb-8">
                <ul className="space-y-3 text-cream-100">
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-cream-400 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg"><strong>Pasaport:</strong> En az 6 ay geçerlilik süresi olan, boş sayfası bulunan pasaport</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-cream-400 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg"><strong>Online Başvuru Formu:</strong> Doldurulmuş ve imzalanmış başvuru formu</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-cream-400 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg"><strong>Randevu Onay Belgesi:</strong> VFS randevu belgesi</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-cream-400 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg"><strong>Mali Durum Belgeleri:</strong> Son 6 ay banka hesap özeti, maaş bordrosu, vergi beyannamesi</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-cream-400 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg"><strong>İş Belgeleri:</strong> İşveren mektubu, SGK hizmet dökümü, şirket evrakları</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-cream-400 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg"><strong>Seyahat Planı:</strong> Uçak rezervasyonu, otel rezervasyonu, seyahat programı</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-cream-400 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg"><strong>Konaklama Belgesi:</strong> Otel rezervasyonu veya davetiye mektubu</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-cream-400 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg"><strong>Geri Dönüş Bağları:</strong> Tapu, araç ruhsatı, aile bağları belgesi</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-cream-400 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg"><strong>Seyahat Geçmişi:</strong> Eski pasaportlar, önceki vizeler</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-cream-400 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg"><strong>Medeni Durum Belgeleri:</strong> Evlilik cüzdanı, nüfus kayıt örneği</span>
                  </li>
                </ul>
              </div>

              <h2 className="font-display text-2xl md:text-4xl font-bold text-navy-900 mb-4 md:mb-6">
                İngiltere Vize Başvurusunda Dikkat Edilmesi Gerekenler
              </h2>
              <div className="grid md:grid-cols-2 gap-6 mb-8">
                <div className="bg-cream-50 rounded-xl p-6 border-2 border-cream-200">
                  <h3 className="font-bold text-navy-900 text-lg mb-3 flex items-center">
                    <i className="ri-money-pound-circle-line text-2xl text-navy-900 mr-2"></i>
                    Mali Yeterlilik
                  </h3>
                  <p className="text-navy-600 text-sm">İngiltere vize başvurularında mali yeterlilik çok önemlidir. Düzenli gelir ve yeterli birikim gösterilmelidir. Günlük minimum 100-120 GBP karşılığı bakiye önerilir.</p>
                </div>
                <div className="bg-cream-50 rounded-xl p-6 border-2 border-cream-200">
                  <h3 className="font-bold text-navy-900 text-lg mb-3 flex items-center">
                    <i className="ri-file-text-line text-2xl text-navy-900 mr-2"></i>
                    Evrak Düzeni
                  </h3>
                  <p className="text-navy-600 text-sm">Tüm belgeler kronolojik sırada ve kategorize edilmiş şekilde sunulmalıdır. İngilizce olmayan belgeler noter onaylı tercüme ile sunulmalıdır.</p>
                </div>
                <div className="bg-cream-50 rounded-xl p-6 border-2 border-cream-200">
                  <h3 className="font-bold text-navy-900 text-lg mb-3 flex items-center">
                    <i className="ri-home-heart-line text-2xl text-navy-900 mr-2"></i>
                    Geri Dönüş Bağları
                  </h3>
                  <p className="text-navy-600 text-sm">İş, aile, mülk gibi Türkiye'ye bağlayan güçlü nedenler net şekilde belgelenmelidir. Bu, vize onay şansını önemli ölçüde artırır.</p>
                </div>
                <div className="bg-cream-50 rounded-xl p-6 border-2 border-cream-200">
                  <h3 className="font-bold text-navy-900 text-lg mb-3 flex items-center">
                    <i className="ri-calendar-check-line text-2xl text-navy-900 mr-2"></i>
                    Seyahat Planı
                  </h3>
                  <p className="text-navy-600 text-sm">Detaylı ve tutarlı bir seyahat planı hazırlanmalıdır. Gidilecek yerler, kalınacak süreler ve aktiviteler net şekilde belirtilmelidir.</p>
                </div>
              </div>

              <h2 className="font-display text-2xl md:text-4xl font-bold text-navy-900 mb-4 md:mb-6">
                Profesyonel Danışmanlık Avantajları
              </h2>
              <div className="bg-gradient-to-br from-cream-400 to-cream-300 rounded-2xl p-6 md:p-8 mb-8">
                <ul className="space-y-3 text-navy-900">
                  <li className="flex items-start">
                    <i className="ri-shield-check-fill text-navy-900 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg"><strong>Form Desteği:</strong> Online başvuru formunun hatasız doldurulmasında yardım</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-shield-check-fill text-navy-900 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg"><strong>Evrak Kontrolü:</strong> Tüm belgelerin eksiksiz ve doğru hazırlanması</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-shield-check-fill text-navy-900 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg"><strong>Randevu Yönetimi:</strong> VFS randevu alma ve süreç takibi</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-shield-check-fill text-navy-900 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg"><strong>Tercüme Desteği:</strong> Gerekli belgelerin noter onaylı tercümesi</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-shield-check-fill text-navy-900 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg"><strong>Süreç Takibi:</strong> Başvurunuzun her aşamasında bilgilendirme</span>
                  </li>
                </ul>
              </div>

              <h2 className="font-display text-2xl md:text-4xl font-bold text-navy-900 mb-4 md:mb-6">
                Sıkça Sorulan Sorular
              </h2>
              <div className="space-y-4 mb-8">
                <div className="bg-white border-2 border-cream-200 rounded-xl p-6">
                  <h3 className="font-bold text-navy-900 text-lg mb-2">İngiltere vizesi kaç günde çıkar?</h3>
                  <p className="text-navy-600">Standard Visitor Visa başvuruları genellikle 15-20 iş günü içinde sonuçlanır. Hızlandırılmış hizmet ile 5 iş gününe düşürülebilir.</p>
                </div>
                <div className="bg-white border-2 border-cream-200 rounded-xl p-6">
                  <h3 className="font-bold text-navy-900 text-lg mb-2">İngiltere vizesi kaç yıl geçerlidir?</h3>
                  <p className="text-navy-600">Standard Visitor Visa genellikle 6 ay geçerlidir. Çok girişli 2, 5 veya 10 yıllık vizeler de başvurulabilir.</p>
                </div>
                <div className="bg-white border-2 border-cream-200 rounded-xl p-6">
                  <h3 className="font-bold text-navy-900 text-lg mb-2">Vize ücreti ne kadar?</h3>
                  <p className="text-navy-600">6 aylık Standard Visitor Visa ücreti yaklaşık 100-115 GBP'dir. Uzun süreli vizeler için ücret daha yüksektir.</p>
                </div>
                <div className="bg-white border-2 border-cream-200 rounded-xl p-6">
                  <h3 className="font-bold text-navy-900 text-lg mb-2">Mülakat var mı?</h3>
                  <p className="text-navy-600">Standard Visitor Visa için genellikle mülakat gerekmez. Ancak bazı durumlarda ek bilgi veya mülakat istenebilir.</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-12 md:py-20 bg-gradient-to-br from-navy-900 to-navy-800">
          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="font-display text-3xl md:text-5xl font-bold text-cream-100 mb-4 md:mb-6">
              İngiltere Vize Başvurunuzu Başlatın
            </h2>
            <p className="text-cream-300 text-base md:text-xl mb-6 md:mb-8 leading-relaxed">
              UK vize süreçlerinde profesyonel destek için bizimle iletişime geçin
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
              <a
                href="https://wa.me/905514803007?text=Merhaba%2C%20karsiyakavisaconsulting.com.tr%20web%20siteniz%20%C3%BCzerinden%20yaz%C4%B1yorum."
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center px-6 py-3 md:px-10 md:py-5 bg-green-600 text-white rounded-full font-bold text-base md:text-xl hover:bg-green-700 transition-all hover:scale-105 shadow-2xl cursor-pointer whitespace-nowrap"
              >
                <i className="ri-whatsapp-fill text-2xl md:text-3xl mr-2 md:mr-3"></i>
                WhatsApp ile İletişim
              </a>
              <a
                href="tel:+905514803007"
                className="inline-flex items-center px-6 py-3 md:px-10 md:py-5 bg-cream-400 text-navy-900 rounded-full font-bold text-base md:text-xl hover:bg-cream-300 transition-all hover:scale-105 shadow-2xl cursor-pointer whitespace-nowrap"
              >
                <i className="ri-phone-fill text-2xl md:text-3xl mr-2 md:mr-3"></i>
                Hemen Ara
              </a>
            </div>
          </div>
        </section>
      </main>

      <Footer />
      <FloatingButtons />
    </div>
  );
};

export default IngiltereVizesiPage;